/**
 * safeEntityUpdate / safeEntityCreate — PostgREST "column not found in
 * schema cache" hatasına dayanıklı yazma.
 *
 * Canlı şemada henüz olmayan bir kolon payload'da varsa PostgREST tüm
 * yazmayı reddeder. Bu yardımcılar, hata mesajından eksik kolonu ayıklar,
 * payload'dan çıkarır ve kalanlarla yeniden dener (en fazla 5 kolon).
 * Böylece eksik migrasyon tek bir alan yüzünden tüm kaydı bloklamaz;
 * atlanan kolonlar çağırana bildirilir.
 */

const MISSING_COL_RE = /the '([^']+)' column|column "([^"]+)" .* does not exist/i;

async function retryWithoutMissingColumns(attemptWrite, payload, maxStrips) {
  let current = { ...payload };
  const skipped = [];

  for (let attempt = 0; attempt <= maxStrips; attempt++) {
    try {
      const data = await attemptWrite(current);
      return { data, skipped };
    } catch (err) {
      const msg = err?.message || '';
      const m = msg.match(MISSING_COL_RE);
      const col = m && (m[1] || m[2]);
      if (!col || !(col in current) || attempt === maxStrips) throw err;
      current = Object.fromEntries(Object.entries(current).filter(([k]) => k !== col));
      skipped.push(col);
    }
  }
  // unreachable
  throw new Error('safeEntityWrite: unerwarteter Zustand');
}

export async function safeEntityUpdate(entity, id, payload, { maxStrips = 5 } = {}) {
  return retryWithoutMissingColumns((p) => entity.update(id, p), payload, maxStrips);
}

export async function safeEntityCreate(entity, payload, { maxStrips = 5 } = {}) {
  return retryWithoutMissingColumns((p) => entity.create(p), payload, maxStrips);
}
